import { Text, View } from '@react-pdf/renderer';
import {
  getProVesselTypeLabel,
  getRiskLevelColor,
  ProReportVesselSpecific,
  ProVesselTypes,
} from '../../../../models/pro.model';
import styles from '../../pro-report-pdf-styles';

interface VesselTypeSpecificRiskTableProps {
  report: ProReportVesselSpecific;
}

function VesselTypeSpecificRiskTable({
  report,
}: VesselTypeSpecificRiskTableProps) {
  if (!report) return null;

  return (
    <View wrap={false} style={styles.table}>
      <View style={styles.tableRow}>
        <Text
          style={{
            ...styles.tableHeaderReducedWidth,
            borderRightWidth: 0,
          }}
        >
          Vessel type
        </Text>
        <Text style={styles.tableHeaderFullWidth}>Port claims risk*</Text>
      </View>
      <View style={styles.tableRow} key={report.vessel_type}>
        <Text
          style={{
            ...styles.tableCellReducedWidth,
            borderRightWidth: 0,
            fontWeight: 'bold',
          }}
        >
          {getProVesselTypeLabel(report.vessel_type as ProVesselTypes)}
        </Text>
        <Text
          style={[
            styles.tableCellFullWidth,
            {
              fontWeight: 'bold',
              color: getRiskLevelColor(report.risk_level),
            },
          ]}
        >
          {report.risk_level}
        </Text>
      </View>
      <Text style={styles.textAsterix}>
        {`*Risk levels by vessel type are based on NorthStandard's claims experience and/or correspondents' advice as outlined below.`}
      </Text>
    </View>
  );
}

export default VesselTypeSpecificRiskTable;
